import { PageContainer } from "./style-component";
import ActivityList from "@/components/activity-list/activity-list";
import CardBalance from "@/components/card-balance/card-balance";
import { getActivities } from "@/services/activity/activity";
import useFetch from "@/hook/useFetch/useFetch";
import { SpaceshipLoader } from "@/components/spaceship-loader/spaceship-loader";
import React, { useEffect, useRef } from "react";
import { useUserContext } from "@/contexts/user/useUserContext";
import brandData from "@/assets/brand.json"
import { amplitudeAddTrack, determineProjectName } from "@/utils/amplitud/event-track";
import SEOHelmet from "@/components/SEOHelmet/SEOHelmet";

const ActivityPage: React.FC = () => {

    const { user, refetchBalance } = useUserContext();

    const firstRender = useRef(true);
    useEffect(() => {
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;
        const fetchData = async () => {
            await refetchBalance?.();
        };
        fetchData();
    }, [refetchBalance]);

    const {
        data: activities,
        loading,
    } = useFetch(getActivities, { wallet: user?.main_key });

    const balance = user?.balance;

    const firstRenderAmplitude = useRef<boolean>(true);
    useEffect(() => {
        if (firstRenderAmplitude.current) {
            firstRenderAmplitude.current = false;
            amplitudeAddTrack(determineProjectName(`Actividad`), {
                title: determineProjectName(`Actividad`),
            })
        }
    }, []);

    return (
        <PageContainer>
            <SEOHelmet
                metadata={{
                    title: determineProjectName(`Actividad`),
                    description: determineProjectName(`Actividad`)
                }}
            />
            <CardBalance
                icon={brandData.pages.wallet.currencies[0].icon}
                amount={balance ?? 0}
                details=""
                symbol={brandData.pages.wallet.currencies[0].symbol}
                title={brandData.pages.wallet.currencies[0].title}
                variant="transparent"
            />

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <SpaceshipLoader height="200px" />
                </div>
            ) : (
                <ActivityList activities={activities || []} />
            )}
        </PageContainer>
    );
};

export default ActivityPage;
